/**
 * Header Component
 * 
 * Displays project metadata and upload button at the top of the page.
 */

import React from 'react';
import { UploadButton } from './UploadButton';
import './Header.css';

/**
 * Page header with song info and controls
 * 
 * @param {object} props - Component props
 * @param {string} props.songName - Project name
 * @param {string} props.songId - Project ID
 * @param {string} props.musicianName - Musician name
 * @param {number} props.bpm - Tempo in BPM
 * @param {[number, number]} props.timeSignature - Time signature [numerator, denominator]
 * @param {string} props.musicKey - Musical key
 * @param {function} props.onUploadClick - Handler for upload button click
 * @param {function} props.onFileChange - Handler for file change
 * @param {React.RefObject} props.inputRef - Ref for file input
 */
export function Header({
  songName,
  songId,
  musicianName,
  bpm,
  timeSignature,
  musicKey,
  onUploadClick,
  onFileChange,
  inputRef,
}) {
  const [numerator, denominator] = timeSignature || [4, 4];
  
  return (
    <div className="header-container">
      <div className="header-column" style={{ textAlign: 'start' }}>
        <p>
          {songName}
          <br />
          {musicianName}
        </p>
      </div>
      
      <UploadButton
        onUploadClick={onUploadClick}
        onFileChange={onFileChange}
        inputRef={inputRef}
      />
      
      <div className="header-column" style={{ textAlign: 'end' }}>
        <p>
          {bpm} BPM
          <br />
          {numerator}/{denominator}
        </p>
      </div>
    </div>
  );
}


